import { css } from '@emotion/css';

export const flashCardStyles = (backgroundColor: string) => css`
  background: ${backgroundColor};
`;

export const flashCardImageStyles = (imageUrl: string) => css`
  background: linear-gradient(0deg, rgba(0, 0, 0, 0.4), rgba(0, 0, 0, 0.4)), url(${imageUrl});
  background-position: center;
  background-size: cover;
`;

export const descriptionStyles = css`
  font-size: 1.8rem;
`;

export const headerStyles = css`
  line-height: 3rem;
`;

export const colorStyles = (color: string) => css`
  color: ${color};
`;

export const textAreaStyles = (color: string) => css`
  color: ${color};
  background: transparent;
  padding: 0rem;
  &::placeholder {
    color: ${color};
    opacity: 0.8;
  }
`;

export const iconStyles = (isPresent: boolean) => css`
  opacity: ${isPresent ? 1 : 0.6};
`;

export const menuListWidth = css`
  width: 14.4rem;
`;

export const iconBorderStyles = (color: string) => css`
  border: 1px solid ${color};
`;

export const iconHoverStyles = (backgroundColor: string) => css`
  &:hover {
    background: ${backgroundColor};
  }
`;
